"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/nb-NO.ts
var nb_NO_exports = {};
__export(nb_NO_exports, {
  AG_CHARTS_LOCALE_NB_NO: () => AG_CHARTS_LOCALE_NB_NO
});
module.exports = __toCommonJS(nb_NO_exports);
var AG_CHARTS_LOCALE_NB_NO = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "lenke ${index} av ${count}, fra ${from} til ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "node ${index} av ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE5lerdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkidiagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niv\xE5 ${level}[number], ${count}[number] barn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Trykk p\xE5 mellomromstasten eller Enter for \xE5 bytte synlighet",
  ariaLabelAddHorizontalLine: "Legg til horisontal linje",
  ariaLabelAnnotationOptionsToolbar: "Merknadsalternativer",
  ariaLabelAnnotationSettingsDialog: "Kommentarinnstillinger",
  ariaLabelColorPicker: "Fargevelger",
  ariaLabelFinancialCharts: "Finansielle diagrammer",
  ariaLabelLegend: "Forklaring",
  ariaLabelLegendItem: "${label}, Legendepost ${index}[number] av ${count}[number]",
  ariaLabelLegendItemUnknown: "Ukjent legendeelement",
  ariaLabelLegendPageNext: "Neste legende side",
  ariaLabelLegendPagePrevious: "Forrige legende-side",
  ariaLabelLegendPagination: "Paginering av legenden",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Omr\xE5de",
  ariaLabelRangesToolbar: "Omr\xE5der",
  ariaLabelSettingsTabBar: "Innstillinger",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] til ${max}[percent0to2dp]",
  contextMenuDownload: "Last ned",
  contextMenuPanToCursor: "Panorer til dette punktet",
  contextMenuToggleOtherSeries: "Sl\xE5 av/p\xE5 andre serier",
  contextMenuToggleSeriesVisibility: "Veksle synlighet",
  contextMenuZoomToCursor: "Zoom hit",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Dato og pris",
  dialogHeaderDateRange: "Datoperiode",
  dialogHeaderFibonacciRange: "Fib Tilbakeretracement",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisklasse",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "Farge",
  dialogInputColorPickerAltText: "Tekstfarge",
  dialogInputExtendAbove: "Forleng over",
  dialogInputExtendBelow: "Utvid nedenfor",
  dialogInputExtendChannelEnd: "Forleng kanalende",
  dialogInputExtendChannelStart: "Utvide kanalstart",
  dialogInputExtendLeft: "Forleng til venstre",
  dialogInputExtendLineEnd: "Forleng linjeslutt",
  dialogInputExtendLineStart: "Forleng linjestart",
  dialogInputExtendRight: "Forleng til h\xF8yre",
  dialogInputFibonacciBands: "B\xE5nd",
  dialogInputFibonacciBandsAltText: "Fibonacci-b\xE5nd",
  dialogInputFillColorPicker: "Fyll",
  dialogInputFillColorPickerAltText: "Fyllfarge",
  dialogInputFontSize: "St\xF8rrelse",
  dialogInputFontSizeAltText: "Skriftst\xF8rrelse",
  dialogInputLineStyle: "Strek",
  dialogInputPosition: "Posisjon",
  dialogInputReverse: "Omvendt",
  dialogInputShowFill: "Vis fyll",
  dialogInputStrokeWidth: "Tykkelse",
  dialogInputStrokeWidthAltText: "Linjetykkelse",
  iconAltTextAlignCenter: "Midtstill",
  iconAltTextAlignLeft: "Venstre",
  iconAltTextAlignRight: "H\xF8yre",
  iconAltTextClose: "Lukk",
  iconAltTextLineStyleDashed: "Lang-stiplet",
  iconAltTextLineStyleDotted: "Kort-stiplet",
  iconAltTextLineStyleSolid: "Heltrukket",
  iconAltTextPositionBottom: "Bunnen",
  iconAltTextPositionCenter: "Senter",
  iconAltTextPositionTop: "Topp",
  inputTextareaPlaceholder: "Legg til tekst",
  measurerDateRangeBars: "${value}[number] s\xF8yler",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volum ${value}",
  overlayLoadingData: "Laster data...",
  overlayNoData: "Ingen data \xE5 vise",
  overlayNoVisibleSeries: "Ingen synlige serier",
  overlayUnsupportedBrowser: "Ukompatibel nettleserversjon. Vennligst oppgrader nettleseren din.",
  seriesHistogramTooltipCount: "${yName} (antall)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (gjennomsnitt)",
  seriesHistogramTooltipSum: "${yName} (sum)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pil ned",
  toolbarAnnotationsArrowUp: "Pil opp",
  toolbarAnnotationsCallout: "Notat",
  toolbarAnnotationsClearAll: "Fjern alt",
  toolbarAnnotationsComment: "Kommenter",
  toolbarAnnotationsDatePriceRange: "Dato og pris",
  toolbarAnnotationsDateRange: "Datoomr\xE5de",
  toolbarAnnotationsDelete: "Slett",
  toolbarAnnotationsDisjointChannel: "Disjoint kanal",
  toolbarAnnotationsDragHandle: "Dra-verkt\xF8ylinje",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fibonnaci Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Basert",
  toolbarAnnotationsFillColor: "Fargefyll",
  toolbarAnnotationsHorizontalLine: "Horisontal linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjefarge",
  toolbarAnnotationsLineStrokeWidth: "Linjeslagbredde",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE5lere",
  toolbarAnnotationsNote: "Notat",
  toolbarAnnotationsParallelChannel: "Parallell kanal",
  toolbarAnnotationsPriceRange: "Prisomr\xE5de",
  toolbarAnnotationsQuickDatePriceRange: "M\xE5l",
  toolbarAnnotationsSettings: "Innstillinger",
  toolbarAnnotationsShapeAnnotations: "Piler",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstanmerkninger",
  toolbarAnnotationsTextColor: "Tekstfarge",
  toolbarAnnotationsTextSize: "Tekstst\xF8rrelse",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s opp",
  toolbarAnnotationsVerticalLine: "Vertikal linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5ned",
  toolbarRange1Year: "1\xC5",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3 mnd",
  toolbarRange3MonthsAria: "3 m\xE5neder",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5neder",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "Hittil i \xE5r",
  toolbarRangeYearToDateAria: "\xC5r til dags dato",
  toolbarSeriesTypeCandles: "Lysestaker",
  toolbarSeriesTypeDropdown: "Diagramtype",
  toolbarSeriesTypeHighLow: "H\xF8y Lav",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Tom lysestake",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF8rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Trinnlinje",
  toolbarZoomPanEnd: "Panorer til slutten",
  toolbarZoomPanLeft: "Panorer til venstre",
  toolbarZoomPanRight: "Panorer til h\xF8yre",
  toolbarZoomPanStart: "Panorer til start",
  toolbarZoomReset: "Tilbakestill zoom",
  toolbarZoomZoomIn: "Zoom inn",
  toolbarZoomZoomOut: "Zoom ut",
  tooltipPaginationStatus: "${index}[number] av ${count}[number]"
};
//# sourceMappingURL=nb-NO.cjs.js.map
